import { types } from 'mobx-state-tree'

// import TrafficCounty from './TrafficCounty'

const TrafficCourt = types
  .model('TrafficCourt', {
    objectId: types.identifier,
    courtName: types.maybeNull(types.string),
    county: types.maybeNull(types.string),
    state: types.maybeNull(types.string),
    trafficCounty: types.maybeNull(types.string),
    available: types.maybeNull(types.boolean)
  })
  .preProcessSnapshot(snapshot => {
    if (!snapshot) return null
    // this function will run on a snapshot to format it before submitting it to the store.
    const parsedSnapshot = {}
    const keys = Object.keys(snapshot)
    keys.forEach(key => {
      const input = snapshot[key]
      switch (key) {
        case 'trafficCounty':
          parsedSnapshot[key] = null
          if (input && typeof input === 'string') {
            parsedSnapshot[key] = input
          }
          if (input && input.objectId) {
            parsedSnapshot[key] = input.objectId
          }
          break
        default:
          parsedSnapshot[key] = input
          break
      }
    })

    return parsedSnapshot
  })

export default TrafficCourt
